import { Injectable } from '@angular/core';
import { CreativeUnitPackage } from "../../../../../../api/src/creative-unit-package/creative-unit-package.entity";
import {
	CreativeUnitPackageDto
} from "../../../../../../api/src/creative-unit-package/models/creative-unit-package.dto";
import { formatDate, recursivelyRetrieveObjectKeys, stringToSlug } from "../../../shared/utils/commonUtil";
import {
	DataExportPackageJsonDialog,
	ExportPackageJsonDialogComponent
} from "../../../shared/components/export-package-json-dialog/export-package-json-dialog.component";
import { BehaviorSubject, first } from "rxjs";
import { CreativeUnitPackageService } from "../../../_core/state/ad/ad-unit-package.service";
import { MatDialog } from "@angular/material/dialog";
import { HttpResponse } from "@angular/common/http";
import { GlobalService } from "../../../_core/state/global";
import { CustomizationUtils } from "../../../../../../api/src/creative-unit-package/utils/customization.utils";

@Injectable({
	providedIn: 'root'
})
export class AdEditorHelperService {
	private creativeUnitListingsDialogStateSubject = new BehaviorSubject<boolean>(false);
	public creativeUnitListingsDialogState$ = this.creativeUnitListingsDialogStateSubject.asObservable();

	constructor(private readonly creativeUnitPackageService: CreativeUnitPackageService,
	            private readonly dialog: MatDialog,
	            private readonly globalService: GlobalService) {
	}


	public async exportCreativePackage(activePackage: CreativeUnitPackage | CreativeUnitPackageDto) {
		/** find and filter for unique datasource **/
		const slugs = CustomizationUtils.getAllCustomizationDataSources(activePackage.customizations || []);

		const filename = `${stringToSlug(activePackage.name)}-${formatDate(activePackage?.modified)}`;

		const response = await this.creativeUnitPackageService.exportCreativePackage(activePackage.id).toPromise();

		if (slugs.length == 0) {
			return this.download(filename, response);
		}

		const exportDialogData: DataExportPackageJsonDialog = {
			title: $localize`:Export package JSON Dialog Title@@exportPackageJsonDialogTitle:Export Creative Package`,
			description: $localize`:Export Package JSON Dialog Description@@exportPackageJsonDialogDescription:Following data sources are used in the package. Make sure to include them in the new environment.`,
			dataSourceSlugs: slugs
		};

		this.dialog
			.open(ExportPackageJsonDialogComponent, {
				width: '640px',
				panelClass: ['background-color-alternative', 'max-width-lg'],
				data: exportDialogData
			})
			.afterClosed()
			.pipe(first())
			.subscribe((dialogResponse: any) => {
				if (!dialogResponse) {
					return;
				}

				this.download(filename, response);
			});
	}

	private download(filename: string, response: HttpResponse<Blob>) {
		try {
			const url = window.URL.createObjectURL(response.body);
			const a = document.createElement('a');
			a.href = url;
			console.log(response.headers.get('content-type'));
			const ext = response.headers.get('content-type') === 'application/zip' ? 'zip' : 'ccetemplate';
			/** format is slug + formatted date **/
			a.download = `${filename}.${ext}`;
			a.click();
			window.URL.revokeObjectURL(url);
		} catch (e) {
			this.globalService.triggerErrorMessage(e);
			console.log(e);
		}
	}

	public setCreativeUnitListingsDialogState(isOpen: boolean) {
		this.creativeUnitListingsDialogStateSubject.next(isOpen);
	}
}
